import { h, FunctionComponent } from 'preact';
import * as styles from '~src/styles/domains/common/components/loading.module.scss';

type LoadingProps = {
  classLabel?: string;
};

const Loading: FunctionComponent<LoadingProps> = ({ classLabel }) => {
  const className = classLabel
    ? `${styles['loading-spinner']} ${classLabel}`
    : styles['loading-spinner'];

  return (
    <svg
      className={className}
      width='33'
      height='32'
      viewBox='0 0 33 32'
      fill='none'
    >
      <mask id='path-1-inside-1_5752_6151' fill='white'>
        <path d='M1.9235 16C1.0451 16 0.32481 16.7138 0.411982 17.5879C0.692614 20.4018 1.71543 23.1015 3.38874 25.4046C5.37478 28.1381 8.17524 30.1728 11.3887 31.2169C14.6022 32.261 18.0638 32.261 21.2773 31.2169C24.4908 30.1728 27.2912 28.1381 29.2773 25.4046C31.2633 22.671 32.333 19.3789 32.333 16C32.333 12.6211 31.2633 9.329 29.2773 6.59543C27.2912 3.86187 24.4908 1.82722 21.2773 0.783094C18.5698 -0.0966148 15.6863 -0.235142 12.9233 0.367514C12.0651 0.554712 11.6088 1.46033 11.8802 2.29575C12.1517 3.13116 13.0484 3.57783 13.911 3.41187C16.0296 3.00422 18.2261 3.1364 20.2943 3.8084C22.8689 4.64494 25.1126 6.27508 26.7038 8.46518C28.295 10.6553 29.152 13.2929 29.152 16C29.152 18.7071 28.295 21.3447 26.7038 23.5348C25.1126 25.7249 22.8689 27.3551 20.2943 28.1916C17.7197 29.0281 14.9463 29.0281 12.3717 28.1916C9.7971 27.3551 7.55341 25.7249 5.96221 23.5348C4.68399 21.7755 3.87954 19.7274 3.61253 17.5865C3.50383 16.7148 2.80191 16 1.9235 16Z' />
      </mask>
      <path
        d='M1.9235 16C1.0451 16 0.32481 16.7138 0.411982 17.5879C0.692614 20.4018 1.71543 23.1015 3.38874 25.4046C5.37478 28.1381 8.17524 30.1728 11.3887 31.2169C14.6022 32.261 18.0638 32.261 21.2773 31.2169C24.4908 30.1728 27.2912 28.1381 29.2773 25.4046C31.2633 22.671 32.333 19.3789 32.333 16C32.333 12.6211 31.2633 9.329 29.2773 6.59543C27.2912 3.86187 24.4908 1.82722 21.2773 0.783094C18.5698 -0.0966148 15.6863 -0.235142 12.9233 0.367514C12.0651 0.554712 11.6088 1.46033 11.8802 2.29575C12.1517 3.13116 13.0484 3.57783 13.911 3.41187C16.0296 3.00422 18.2261 3.1364 20.2943 3.8084C22.8689 4.64494 25.1126 6.27508 26.7038 8.46518C28.295 10.6553 29.152 13.2929 29.152 16C29.152 18.7071 28.295 21.3447 26.7038 23.5348C25.1126 25.7249 22.8689 27.3551 20.2943 28.1916C17.7197 29.0281 14.9463 29.0281 12.3717 28.1916C9.7971 27.3551 7.55341 25.7249 5.96221 23.5348C4.68399 21.7755 3.87954 19.7274 3.61253 17.5865C3.50383 16.7148 2.80191 16 1.9235 16Z'
        stroke='#4A9D2D'
        stroke-width='35.2'
        mask='url(#path-1-inside-1_5752_6151)'
      />
    </svg>
  );
};

export default Loading;
